/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as LogRouteImport } from './routes/log'
import { Route as PlatesRouteImport } from './routes/plates'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LogRoute = LogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatesRoute = PlatesRouteImport.update({
  id: '/plates',
  path: '/plates',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/log': typeof LogRoute
  '/plates': typeof PlatesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/log': typeof LogRoute
  '/plates': typeof PlatesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/log': typeof LogRoute
  '/plates': typeof PlatesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/admin' | '/log' | '/plates'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/admin' | '/log' | '/plates'
  id: '__root__' | '/' | '/admin' | '/log' | '/plates'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  LogRoute: typeof LogRoute
  PlatesRoute: typeof PlatesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/log': {
      id: '/log'
      path: '/log'
      fullPath: '/log'
      preLoaderRoute: typeof LogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plates': {
      id: '/plates'
      path: '/plates'
      fullPath: '/plates'
      preLoaderRoute: typeof PlatesRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  LogRoute: LogRoute,
  PlatesRoute: PlatesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
